export default {
  breakingDetail: '/product/detail',// bk
  bidDetail: '/product/detail', // 拍卖
  goodCardDetail:'/product/detail', // 好卡
  boxDetail:'/product/detail', // 范盒-福盒
  bagDetail: '/product/detail', // 范盒-福袋
  normalDetail: '/product/detail', // 范盒-标品
  saleCalendarDetail: '/saleCalendar/detail', // 范盒-标品
  c2cMerchantIndex: '/c2c/merchant/index', // c2c-商家列表
}
